export default __webpack_public_path__ + "static/media/mftv_mf-tv.e538d5f6.svg";